// extracted by mini-css-extract-plugin
module.exports = {"customerCard":"customersimplified_customerCard__3UuIm","selectIcon":"customersimplified_selectIcon__2vZNB","overlay":"customersimplified_overlay__5UopW"};